<script>
    import classnames from 'classnames';
    import I18n from '@js/modules/translations';

    const {
        class: className
    } = $props();

    const slopeRanges = [
        {color: '#4CAF50', label: '0–5%'},
        {color: '#FFC107', label: '5–10%'},
        {color: '#FF9800', label: '10–15%'},
        {color: '#FF5722', label: '15–20%'},
        {color: '#F44336', label: '20%+'}
    ];
</script>

<div class={classnames('map-slope-legend', className)}>
    <div class="slope-legend-title">
        {I18n.t('js.maps.toolbar.slope_color.legend_title')}
    </div>

    <div class="slope-legend-items">
        {#each slopeRanges as range (range)}
            <div class="slope-legend-item">
                <span class="slope-legend-color"
                      style="background-color: {range.color}"></span>
                <span class="slope-legend-label">{range.label}</span>
            </div>
        {/each}
    </div>
</div>
